import React from "react";

const Metrics = () => {
  return (
    <div>
      <h1>Visualización de Métricas</h1>
      <p>Consulta las métricas y estadísticas del sitio.</p>
    </div>
  );
};

export default Metrics;
